
import { TransactionTable as RefactoredTransactionTable } from "./transaction-table/TransactionTable";

export function TransactionTable() {
  return <RefactoredTransactionTable />;
}
